/** Shared SCLA program copy for the application home. */

export const SCLA_PROGRAM_SUMMARY =
  "The Summer Coding Leadership Academy (SCLA) is Teens Exploring Technology's (TXT) flagship program. SCLA is a wonderful opportunity for talented inner-city young men to immerse themselves in the leadership, coding, and entrepreneurial skills needed to be the leading tech magnates of tomorrow during an 8-week long program.";

export const SCLA_ELIGIBILITY =
  'Boys currently enrolled in 8th to 10th grade as of the application deadline date.';

export const SCLA_DEMO_DAY =
  "After weeks of hard work, learning, and innovation, you and your team will take the stage to pitch your groundbreaking product to top industry executives and investors. The winning team will receive funding and mentorship to launch their very own teen tech startup, turning their vision into reality. This is your chance to showcase everything you've accomplished during the program, prove your skills, and take the first step toward becoming a leader in the tech industry.";

export const SCLA_DEMO_DAY_CLOSE =
  'Do you have what it takes to compete at the highest level? Apply now and take your shot at innovation, investment, and impact!';

export const SCLA_WHAT_YOU_NEED =
  'Transcripts, short responses, parent signature. Letter of rec optional.';

export const SCLA_TIME_NOTE =
  'About 30 minutes. Your progress saves as you go.';

/** The three things students do at SCLA, shown under the program summary. */
export const SCLA_HIGHLIGHTS = [
  {
    title: 'Launch your own business',
    body: 'Work with your team to turn an idea into a real tech startup, from the problem you solve to your business plan.',
  },
  {
    title: 'Design and code your own app',
    body: 'Learn design and coding from scratch, then build a working web or mobile app for your business.',
  },
  {
    title: 'Win up to $3k in funding',
    body: 'Pitch your business to industry executives and investors at Demo Day for funding and mentorship.',
  },
  {
    title: 'Visit top tech companies',
    body: 'Tour companies like Snap, Google and Riot Games and network with the professionals who work there.',
  },
];
